import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://joweyluxe.com';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

export default function SEO({ title, description, path = '/', image = DEFAULT_IMAGE, jsonLd }) {
  const url = `${SITE_URL}${path === '/' ? '' : path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
